export const visit = (vm, at) => {
at({ "en": { "breezeSetupProspectingAgent": { "setupPrompt": "Help me set up my prospecting agent." } } });
};